import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import TemplateGenerator from "../components/portal/TemplateGenerator";
import ExpiredWish from "../components/wishes/ExpiredWish";

export default function WishPage() {
    const { token } = useParams();
    const [loading, setLoading] = useState(true);
    const [expiredOrNotFound, setExpiredOrNotFound] = useState(false);
    const [wish, setWish] = useState(null);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        let active = true;
        (async () => {
            setLoading(true);
            try {
                const res = await fetch(`/api/wish/showByToken/${encodeURIComponent(token)}`, {
                    headers: { Accept: "application/json" },
                });

                if (res.status === 404 || res.status === 410 || !res.ok) {
                    if (active) setExpiredOrNotFound(true);
                    return;
                }

                const data = await res.json();
                if (active) {
                    const w = data?.wish ?? null;
                    setWish(w);
                    setRows(Array.isArray(data?.wishTexts) ? data.wishTexts : []);
                }
            } catch {
                if (active) setExpiredOrNotFound(true);
            } finally {
                if (active) setLoading(false);
            }
        })();
        return () => { active = false; };
    }, [token]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-pink-50">
                <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="text-center">
                    <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                        <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    </div>
                    <p className="text-gray-600 text-lg">Loading your special wish...</p>
                </motion.div>
            </div>
        );
    }

    if (expiredOrNotFound || !wish) return <ExpiredWish />;

    return (
        <div className="fixed inset-0 m-0 p-0 overflow-hidden">
            <TemplateGenerator wish={wish} rows={rows} />
        </div>
    );
}
